import type { ReactNode } from "react";
import { useMemo } from "react";
import { Navigate } from "react-router-dom";

import { path } from "@/routes/path";
import { useUserStore } from "@/stores/userStore";
import type { IRole } from "@/interfaces";
import { Component as DoctorDashboard } from "@/pages/panelPages/dashboard/doctorDashboard";
import { Component as PatientDashboard } from "@/pages/panelPages/dashboard/patientDashboard";
import { Component as SuperAdminDashboard } from "@/pages/panelPages/dashboard/superAdminDashboard";
import { Component as StaffDashboard } from "@/pages/panelPages/dashboard/staffDashboard";
import { Component as LocalAdminDashboard } from "@/pages/panelPages/dashboard/localAdminDashboard";
import { Component as AdminDashboard } from "@/pages/panelPages/dashboard/adminDashboard";
import { Component as MspDashboard } from "@/pages/panelPages/dashboard/mspDashboard";

function App() {
  const role = useUserStore((state) => state.role);
  // const { data } = useProfile()

  const dashboardComponent = useMemo(() => {
    if (role === null) {
      // Default component for null role
      return <div>{"No Role Defined"}</div>;
    }

    const components: Record<IRole, ReactNode> = {
      doctor: <DoctorDashboard />,
      "local-admin": <LocalAdminDashboard />,
      patient: <PatientDashboard />,
      staff: <StaffDashboard />,
      "super-admin": <SuperAdminDashboard />,
      admin: <AdminDashboard />,
      "inactive-patient": (
        <Navigate to={path.financialRecords.walletBalance.link()} />
      ),
      "medical-service-provider-drug": <MspDashboard />,
      "medical-service-provider-lab": <MspDashboard />,
      "medical-service-provider-image": <MspDashboard />,
    };

    return components[role as IRole] || <div>{"Invalid Role"}</div>;
  }, [role]);

  return <>{dashboardComponent}</>;
}

export default App;
